import React from 'react';

import { IconProps, StyledPath, StyledStrokedGroup, StyledSvg } from '../iconCommons';

export const IconExternalLink = ({ color = 'currentColor', size = 'medium', ...props }: IconProps) => (
    <StyledSvg size={size} {...props} viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
        <StyledStrokedGroup color={color}>
            <StyledPath
                d="M15.5 5.999v-4.5H11M15.5 1.499l-10 10M7.5 4.499h-6a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-6"
                color="none"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </StyledStrokedGroup>
    </StyledSvg>
);
